import React from 'react'

import { isString } from 'lodash-es'

import './loadingOverlay.css'

const LOADING_OVERLAY_CLASS = 'loading-overlay-container'

interface LoadingOverlayProps {
  loading: boolean
  children: React.ReactNode
  classes?: string
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  loading,
  children,
  classes,
}) => {
  const class_names = `${LOADING_OVERLAY_CLASS}${isString(classes) ? ' ' + classes : ''}`
  return (
    <div className={class_names}>
      {children}
      {loading ? (
        <div id="loader-wrapper">
          <div id="loader"></div>
        </div>
      ) : null}
    </div>
  )
}
